export default __webpack_public_path__ + "static/media/collection-icon.76229d28.svg";